import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DepertmentService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllDepertmant() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Depertment
    });
    return await firstValueFrom(observable);
  }

  async getAllForUserProjectDepertmant() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Depertment,
      action:"GetAllForUserProjectDepertmant"
    });
    return await firstValueFrom(observable);
  }

  async createDepertmant(name) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Depertment
    }, {
      name:name
    });
    return await firstValueFrom(observable);
  }

  async updateDepertmant(id, name) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Depertment
    }, {
      id:id,
      name:name
    });
    return await firstValueFrom(observable);
  }
}
